import { render, staticRenderFns } from "./DateWithNow.vue?vue&type=template&id=546bc147&scoped=true&"
import script from "./DateWithNow.vue?vue&type=script&lang=js&"
export * from "./DateWithNow.vue?vue&type=script&lang=js&"
import style0 from "./DateWithNow.vue?vue&type=style&index=0&id=546bc147&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546bc147",
  null
  
)

export default component.exports